export enum alertType {
  INFORMATION = 'information',
  ALERT = 'alert',
}
